/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Section_IdentificationInputs */

const en_clients_section_identification = /** @type {(inputs: Clients_Section_IdentificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Identification`)
};

const pt_br2_clients_section_identification = /** @type {(inputs: Clients_Section_IdentificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Identificação`)
};

/**
* | output |
* | --- |
* | "Identification" |
*
* @param {Clients_Section_IdentificationInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_section_identification = /** @type {((inputs?: Clients_Section_IdentificationInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Section_IdentificationInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_section_identification(inputs)
	return pt_br2_clients_section_identification(inputs)
});